module.exports = __webpack_public_path__ + "assets/matomo-analytics.1bb42159.svg";